export default {
      id: "Icon--edit-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite.svg#Icon--edit",
      toString: function () {
        return this.url;
      }
    }